import { ActionType } from "../action-types";
import { Action } from "../actions";

interface GlobalErrorState {
  errors: { status: number; message: string }[];
}

const initialState: GlobalErrorState = {
  errors: [],
};

const reducer = (
  state: GlobalErrorState = initialState,
  action: Action
): GlobalErrorState => {
  switch (action.type) {
    case ActionType.ADD_GLOBAL_ERROR:
      return { ...state, errors: [...state.errors, action.payload] };
    case ActionType.REMOVE_GLOBAL_ERROR:
      return {
        ...state,
        errors: state.errors.filter((_, idx) => idx !== action.payload),
      };
    case ActionType.CLEAR_GLOBAL_ERROR:
      return { ...state, errors: [] };
    default:
      return state;
  }
};

export default reducer;
